import React, { useState } from "react";
import "../../Assets/Css/MovieTrailerPopup.css";
import playIcon from "../../Assets/Images/PlayIcon.svg";
import closeIcon from "../../Assets/Images/CancelIcon.png";
import ahaIcon from "../../Assets/Images/aha.svg";
import jioIcon from "../../Assets/Images/hotstar.svg";

const MovieTrailerPopup = ({ onClose, movie }) => {
  const [isPlaying, setIsPlaying] = useState(false);

  // Function to get YouTube embed URL from regular URL
  const getYouTubeEmbedUrl = (url) => {
    if (!url || typeof url !== "string" || url.trim() === "") {
      return null; // Return null if the URL is empty or invalid
    }
    const videoId = url.split("v=")[1];
    if (!videoId) return null; // Return null if no video ID is found
    const ampersandPosition = videoId.indexOf("&");
    if (ampersandPosition !== -1) {
      return `https://www.youtube.com/embed/${videoId.substring(0, ampersandPosition)}`;
    }
    return `https://www.youtube.com/embed/${videoId}`;
  };

  // Determine which watch icon to use
  const getWatchIcon = () => {
    const platform = movie.button[0];
    if (platform === "aha") return ahaIcon;
    if (platform === "jio") return jioIcon;
    return null;
  };

  const watchIcon = getWatchIcon();
  const hasWatchButton = movie.button[0] !== " ";
  const embedUrl = getYouTubeEmbedUrl(movie.link); // Get embed URL or null

  const handlePlayClick = () => {
    if (embedUrl) {
      setIsPlaying(true);
    }
  };

  const handleWatchClick = () => {
    if (movie.ottLink) {
      window.open(movie.ottLink, "_blank"); // Open the OTT link in a new tab
    }
  };

  return (
    <div className="movie-popup">
      <div className="popup-background" style={{ backgroundImage: `url(${movie.background})` }}>
        <button className="close-btn" onClick={onClose}>
          <img src={closeIcon} alt="Close" />
        </button>
        
        {!isPlaying ? (
          embedUrl && ( // Only show play button if there's a valid embed URL
            <div className="mtplay-button" onClick={handlePlayClick}>
              <img src={playIcon} alt="Play Trailer" />
              <span>Play Trailer</span>
            </div>
          )
        ) : (
          <div className="video-overlay">
            <iframe
              width="100%"
              height="100%"
              src={`${embedUrl}?autoplay=1`}
              title={movie.title}
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>
        )}

        <div className="movie-info">
          <h2>{movie.title}</h2>
          <p>{movie.description}</p>
          {hasWatchButton && watchIcon && (
            <button className="watch-button" onClick={handleWatchClick}>
              Watch it on <img src={watchIcon} alt="Watch" />
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default MovieTrailerPopup;